module.exports = __webpack_public_path__ + "static/media/Covid.5a9263da.jpg";